import navigation from "@/constants/navigation";
import userManager from "@/assets/plugins/mps-common/user/user-manager";

function isEmptyPermission(permission) {
    return permission == null || permission === "";
}

/**
 * 사이드 메뉴 순서대로, 유저가 접근 가능한 첫 라우트 name 을 찾습니다.
 * (메뉴 노출 규칙과 동일: 상위 권한이 없으면 하위도 스킵)
 */
function findFirstAccessibleRouteName(menus, parentPermission = null) {
    for (const menu of menus) {
        if (!isEmptyPermission(menu.permission) && !userManager.hasPermission(menu.permission)) {
            continue;
        }

        const permission = isEmptyPermission(menu.permission) ? parentPermission : menu.permission;

        if (menu.children && menu.children.length > 0) {
            const childRouteName = findFirstAccessibleRouteName(menu.children, permission);
            if (childRouteName) {
                return childRouteName;
            }
        }

        if (menu.id) {
            const leafPermission = isEmptyPermission(menu.permission) ? parentPermission : menu.permission;
            if (isEmptyPermission(leafPermission) || userManager.hasPermission(leafPermission)) {
                return menu.id;
            }
        }
    }
    return null;
}

/**
 * 로그인 후 이동할 기본 경로.
 * SYSTEM__MEMBERSHIP 가 있으면 사이드 메뉴 첫 항목인 업무 현황으로 이동합니다.
 * 권한이 하나도 없으면 권한 없음 페이지로 이동합니다.
 */
export function resolveAuthenticatedHomePath(router) {
    const routeName = findFirstAccessibleRouteName(navigation.SIDE_MENU);
    if (routeName) {
        const resolved = router.resolve({name: routeName});
        if (resolved && resolved.route && resolved.route.name === routeName) {
            return resolved.href;
        }
    }
    return "/has-any-no-permission";
}
